module.exports = __webpack_public_path__ + "media/images/chatbot-mascot2-b794a5d9.png";